// extracted by mini-css-extract-plugin
export default {"titleHeader":"TitleHeader_titleHeader__hwK8Y"};